module.exports = __webpack_public_path__ + "img/video-teacher.12eee46a.png";